export default "__VITE_ASSET__B3ILG2U8__"